import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import OpenCallPage from "@/pages/OpenCallPage";
import ArtistIntakePage from "@/pages/ArtistIntakePage";
import WhatIsHumanity from "@/pages/WhatIsHumanity";
import AdminLogin from "@/admin/pages/LoginPage";
import AdminDashboard from "@/admin/pages/DashboardPage";
import AdminExhibitions from "@/admin/pages/ExhibitionsPage";
import AdminTickets from "@/admin/pages/TicketsPage";
import AdminOpenCall from "@/admin/pages/OpenCallListPage";
import AdminOpenCallDetail from "@/admin/pages/OpenCallDetailPage";
import AdminArtists from "@/admin/pages/ArtistsPage";
import AdminArtistDetail from "@/admin/pages/ArtistDetailPage";
import AdminEmailConsole from "@/admin/pages/EmailConsolePage";
import AdminSettings from "@/admin/pages/SettingsPage";
import AdminExhibitionFlow from "@/admin/pages/ExhibitionFlowPage";
import AdminInvite from "@/admin/pages/InvitePage";
import AdminQRCodes from "@/admin/pages/QRCodePage";
import AdminArtworks from "@/admin/pages/ArtworksPage";
import AdminArtworkEditor from "@/admin/pages/ArtworkEditorPage";
import AdminUsers from "@/admin/pages/UsersPage";
import AdminInviteAccept from "@/admin/pages/InviteAcceptPage";
import PublicArtworkPage from "@/pages/PublicArtworkPage";
import PublicArtworksPage from "@/pages/PublicArtworksPage";
import PublicArtistPage from "@/pages/PublicArtistPage";
import PublicArtistsPage from "@/pages/PublicArtistsPage";
import PublicExhibitionPage from "@/pages/PublicExhibitionPage";
import PublicPaymentPage from "@/pages/PublicPaymentPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";
import CardBuyPage from "@/pages/CardBuyPage";
import CardSuccessPage from "@/pages/CardSuccessPage";
import CardQRPrintPage from "@/pages/CardQRPrintPage";
import ThisIsHumanityCardsPage from "@/pages/ThisIsHumanityCardsPage";
import SalesLayout from "@/admin/components/sales/SalesLayout";
import SalesDashboardPage from "@/admin/pages/sales/SalesDashboardPage";
import SalesClientsPage from "@/admin/pages/sales/SalesClientsPage";
import SalesCardsPage from "@/admin/pages/sales/SalesCardsPage";
import SalesDrawsPage from "@/admin/pages/sales/SalesDrawsPage";
import SalesSettingsPage from "@/admin/pages/sales/SalesSettingsPage";
import AdminLayout from "@/admin/AdminLayout";
import { AuthProvider } from "@/admin/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/opencall" element={<OpenCallPage />} />
          <Route path="/artist-intake" element={<ArtistIntakePage />} />
          <Route path="/whatishumanity" element={<WhatIsHumanity />} />
          <Route path="/whatishumanity/gallery" element={<WhatIsHumanity />} />
          <Route path="/artists" element={<PublicArtistsPage />} />
          <Route path="/artists/:slug" element={<PublicArtistPage />} />
          <Route path="/artworks" element={<PublicArtworksPage />} />
          <Route path="/artworks/:slug" element={<PublicArtworkPage />} />
          <Route path="/exhibitions/:slug" element={<PublicExhibitionPage />} />
          <Route path="/p/:publicCode" element={<PublicPaymentPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/payment/cancel" element={<PaymentCancelPage />} />
          <Route path="/cards" element={<CardBuyPage />} />
          <Route path="/cards/buy" element={<CardBuyPage />} />
          <Route path="/cards/success" element={<CardSuccessPage />} />
          <Route path="/cards/qr" element={<CardQRPrintPage />} />
          <Route path="/thisishumanitycards" element={<ThisIsHumanityCardsPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/invite/:token" element={<AdminInviteAccept />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="exhibitions" element={<AdminExhibitions />} />
            <Route path="tickets" element={<AdminTickets />} />
            <Route path="open-call" element={<AdminOpenCall />} />
            <Route path="open-call/:id" element={<AdminOpenCallDetail />} />
            <Route path="artists" element={<AdminArtists />} />
            <Route path="artists/:id" element={<AdminArtistDetail />} />
            <Route path="email-console" element={<AdminEmailConsole />} />
            <Route path="exhibition-flow" element={<AdminExhibitionFlow />} />
            <Route path="invite" element={<AdminInvite />} />
            <Route path="qr" element={<AdminQRCodes />} />
            <Route path="artworks" element={<AdminArtworks />} />
            <Route path="artworks/new" element={<AdminArtworkEditor />} />
            <Route path="artworks/:id" element={<AdminArtworkEditor />} />
            <Route path="sales" element={<SalesLayout />}>
              <Route index element={<SalesDashboardPage />} />
              <Route path="clients" element={<SalesClientsPage />} />
              <Route path="cards" element={<SalesCardsPage />} />
              <Route path="draws" element={<SalesDrawsPage />} />
              <Route path="settings" element={<SalesSettingsPage />} />
            </Route>
            <Route path="users" element={<AdminUsers />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
